<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-6 px-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Inventario</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#4318FF" class="mr-2">mdi-package-variant-closed</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Control de productos y stock de LIVE FIT
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-md-end align-center">
        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar producto..."
          solo-inverted flat hide-details
          class="rounded-lg mr-4"
          style="max-width: 300px"
        ></v-text-field>
        <v-btn color="#4318FF" dark class="rounded-lg elevation-1 text-none font-weight-bold" @click="abrirDialogo">
          <v-icon left>mdi-plus</v-icon> Nuevo Producto
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="rounded-xl elevation-1 border-0 pa-4">
      <v-data-table :headers="headers" :items="productos" :loading="cargando" :search="busqueda" class="elevation-0">
        <template v-slot:[`item.nombre`]="{ item }">
          <div class="d-flex align-center py-2">
            <v-avatar size="45" class="mr-3 list-avatar elevation-1" color="#F4F7FE">
              <v-img :src="urlImagen(item.imagen)" />
            </v-avatar>
            <span class="font-weight-bold" style="color: #1B2559;">{{ item.nombre }}</span>
          </div>
        </template>

        <template v-slot:[`item.precioVenta`]="{ item }">
          <span class="font-weight-black green--text">S/ {{ item.precioVenta }}</span>
        </template>

        <template v-slot:[`item.existencia`]="{ item }">
          <v-chip :color="item.existencia < 5 ? 'error' : 'success'" small dark class="font-weight-bold">
            {{ item.existencia }} unid.
          </v-chip>
        </template>

        <template v-slot:[`item.acciones`]="{ item }">
          <div class="d-flex justify-end">
            <v-btn icon class="action-edit" @click="prepararEdicion(item)"><v-icon small>mdi-pencil-outline</v-icon></v-btn>
            <v-btn icon class="action-danger" @click="eliminar(item)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogo" max-width="550px" persistent>
      <v-card class="rounded-xl pa-4">
        <v-card-title class="text-h5 font-weight-black justify-center" style="color: #1B2559;">
          {{ editando ? 'Actualizar Producto' : 'Nuevo Producto' }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" class="mb-6">
              <v-avatar size="120" class="rounded-xl elevation-2 border" color="#F4F7FE">
                <v-img :src="form.imagen_preview || 'img/default-prod.png'"></v-img>
              </v-avatar>
              <v-file-input label="Cambiar Foto" outlined dense hide-details @change="procesarImagen" prepend-icon="mdi-camera" class="mt-4" style="width: 100%"></v-file-input>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6"><v-text-field v-model="form.codigo" label="Código / SKU" outlined dense></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field v-model="form.nombre" label="Nombre" outlined dense></v-text-field></v-col>
              <v-col cols="4"><v-text-field v-model="form.precioCompra" label="Costo" prefix="S/" type="number" outlined dense></v-text-field></v-col>
              <v-col cols="4"><v-text-field v-model="form.precioVenta" label="Venta" prefix="S/" type="number" outlined dense></v-text-field></v-col>
              <v-col cols="4"><v-text-field v-model="form.existencia" label="Stock" type="number" outlined dense></v-text-field></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn text class="text-none font-weight-bold" @click="dialogo = false">Cancelar</v-btn>
          <v-btn color="#4318FF" dark class="rounded-lg px-8 text-none font-weight-bold" @click="guardar" :loading="cargando">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="mostrarMensajeEliminar" :timeout="4000" color="error" top rounded="pill">
      {{ mensajeEliminar }}
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from "../Servicios/HttpService";
import Utiles from "../Servicios/Utiles";

export default {
  data: () => ({
    cargando: false, dialogo: false, editando: false, productos: [], busqueda: "",
    headers: [
      { text: 'Producto', value: 'nombre' },
      { text: 'Precio Venta', value: 'precioVenta' },
      { text: 'Stock Actual', value: 'existencia', align: 'center' },
      { text: 'Opciones', value: 'acciones', align: 'end', sortable: false },
    ],
    form: { id: null, codigo: '', nombre: '', precioCompra: 0, precioVenta: 0, existencia: 0, imagen_base64: '', imagen_preview: '' },
    mensajeEliminar: "",
    mostrarMensajeEliminar: false,
  }),
  mounted() { this.obtener(); },
  methods: {
    async obtener() {
      this.cargando = true;
      const res = await HttpService.obtenerConDatos({ metodo: "obtener" }, "productos.php");
      this.productos = Array.isArray(res) ? res : [];
      this.cargando = false;
    },
    procesarImagen(file) {
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => { this.form.imagen_preview = e.target.result; this.form.imagen_base64 = e.target.result; };
      reader.readAsDataURL(file);
    },
    async guardar() {
      this.cargando = true;
      const payload = { metodo: this.editando ? "editar" : "insertar", producto: this.form };
      const res = await HttpService.obtenerConDatos(payload, "productos.php");
      if (res.resultado) { this.dialogo = false; await this.obtener(); }
      this.cargando = false;
    },
    urlImagen(imagen) {
      return Utiles.generarURL(imagen, 'productos');
    },
    prepararEdicion(item) {
      this.editando = true;
      this.form = { ...item, imagen_preview: this.urlImagen(item.imagen) };
      this.dialogo = true;
    },
    async eliminar(item) {
      if (confirm(`¿Eliminar ${item.nombre}?`)) {
        const res = await HttpService.obtenerConDatos({ metodo: "eliminar", id: item.id }, "productos.php");
        if (res === true || (res && res.resultado)) {
          await this.obtener();
        } else if (res && res.mensaje) {
         
          this.mensajeEliminar = res.mensaje;
          this.mostrarMensajeEliminar = true;
        } else {
          alert("No se pudo eliminar el producto.");
        }
      }
    },
    abrirDialogo() {
      this.editando = false;
      this.form = { id: null, codigo: '', nombre: '', precioCompra: 0, precioVenta: 0, existencia: 0, imagen_base64: '', imagen_preview: '' };
      this.dialogo = true;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/InventarioComponent.vue